/* eslint-disable no-param-reassign */

xplenty.service('headersService', [
  '$http',

  function ($http) {
    const headersService = {};

    headersService.init = function () {
      $http.defaults.useXDomain = true;
      // $http.defaults.headers.common['Authorization'] = 'Basic N1Zld3p5SlV6WHhHc3BUWVEzZjE6N1Zld3p5SlV6WHhHc3BUWVEzZjE=';
      // $http.defaults.headers.common['Authorization'] = 'Bearer ' + auth.getToken();
      $http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      $http.defaults.headers.common.Accept = 'application/vnd.xplenty+json; version=2';
    };

    headersService.add = function (name, value) {
      $http.defaults.headers.common[name] = value;
    };

    headersService.remove = function (name) {
      delete $http.defaults.headers.common[name];
    };

    return headersService;
  },
]);
